import { createContexts } from '../../utils';

import type { EventDefinition } from '../../types';

export const integration_card_action: EventDefinition = {
  getData: (action) => {
    switch (action) {
      case 'click_install':
      case 'click_uninstall':
      case 'click_connect':
      case 'click_waitlist':
      case 'click_contact_support':
      case 'click_resume_install':
        return { type: action };
      default:
        return {};
    }
  },
  addContexts: ({ eventData } = {}) =>
    createContexts(['integration'], {
      eventData: {
        integration: { slug: eventData?.slug },
      },
    }),
};
